import React from "react";
import { Route, Routes } from "react-router-dom";

import { Menu } from "../components/Navbar/Menu";
import { Footer } from "../components/Navbar/Footer";
import { Login } from "../pages/Login";
import { useUserAdmin } from "../admin/UserContext";
import AdminLayout from "../Routes/AdminLayout"


import { InicioHazel } from "../pages/Inicio";
import { IndexContacto } from "../pages/Contacto";
import { IndexServicio } from "../pages/Servicio";
import { IndexNosotros } from "../pages/Nosotros";
import { PaginaProducto } from "../pages/Producto";
import { PaginaEspecificaProducto } from "../pages/PaginaProductoEspecifico";

/* administrador */
import { InicioAdministrador } from "../pages/Login/General/InicioAdministrador";
import { PortadaInicioAdministrador } from "../pages/Login/PaginaInicioAdministrador/Portada";
import { ProductoInicioAdministrador } from "../pages/Login/PaginaInicioAdministrador/ProductoHome";
import { InicioServicioHomeAdmin } from "../pages/Login/PaginaInicioAdministrador/ServicioHome";
import { IndexProductosAdmin } from "../pages/Login/Productos/PaginaProductosAdmin";
import { Reporte } from "../pages/Login/General/Reporte";
import { Correo } from "../pages/Login/General/correo";
import { PaginaIndexPorcentajeAdmin } from "../pages/Login/PaginaInicioAdministrador/PorcentajeInicio";
import { PortadNosotrosAdmin } from "../pages/Login/Nosotros/PortadaNosotros";
import { PaginaJosemarAdmin } from "../pages/Login/Nosotros/PaginaJosemar";
import { PaginaIconoJosemarAdmin } from "../pages/Login/Nosotros/PaginaIconoJosemarAdmin";

export const Layout = () => {
  const { Token } = useUserAdmin();
  const isAuthenticated = Boolean(Token);

  return (
    <>
      {!isAuthenticated && <Menu />}

      <Routes>

        {!isAuthenticated && (
          <>
            <Route element={<InicioHazel />} path="/" />
            <Route element={<Login />} path="/administrador" />
            <Route element={<IndexContacto />} path="/contacto" />
            <Route element={<IndexServicio />} path="/servicio" />
            <Route element={<IndexNosotros />} path="/nosotros" />
            <Route element={<PaginaProducto />} path="/producto" />
            <Route element={<PaginaEspecificaProducto />} path="/producto/hod/:id/:id_categoria" />
          </>
        )}
        {isAuthenticated && (
          <Route
            path="/*"
            element={
              <AdminLayout>
                <Routes>
                  <Route element={<InicioAdministrador />} path="/inicio/administrador" />
                  <Route element={<PortadaInicioAdministrador />} path="/administrador/Portada/pagina/Inicio" />
                  <Route element={<ProductoInicioAdministrador />} path="/administrador/Producto/pagina/Inicio" />
                  <Route element={<InicioServicioHomeAdmin />} path="/administrador/servicio/pagina/Inicio" />
                  <Route element={<IndexProductosAdmin />} path="/administrador/productos/pagina/Inicio" />
                  <Route element={<Reporte />} path="/administrador/reporte" />
                  <Route element={<Correo />} path="/administrador/correo" />
                  <Route element={<PaginaIndexPorcentajeAdmin />} path="/administrador/porcentaje/admin" />
                  <Route element={<PortadNosotrosAdmin/>} path="/administrador/portadanosotros/admin" /> 
                  <Route element={<PaginaJosemarAdmin/>} path="/administrador/josemar/admin" /> 
                  <Route element={<PaginaIconoJosemarAdmin/>} path="/administrador/icono/admin" /> 





                </Routes>
              </AdminLayout>
            }
          />
        )}


      </Routes>
      {!isAuthenticated && <Footer />}

    </>
  )

}